import React, { useState, useEffect, useMemo } from "react";
import BackMethods from "../../back_component/BackMethods";
import img from "../../1.webp";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function AllVisitsPage() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { backEnd_request, getUserConstraints } = BackMethods();

    const {
        userGovernorate,
        userCity,
        isSuperAdmin,
    } = getUserConstraints();
    // --- دالة للحصول على القيمة من الـ URL أو الـ SessionStorage أو الافتراضي ---
    const getInitialValue = (key, defaultValue) => {
        const urlValue = searchParams.get(key);
        if (urlValue !== null) return urlValue;

        const saved = sessionStorage.getItem("all_visits_filters");
        if (saved) {
            const parsed = JSON.parse(saved);
            return parsed[key] !== undefined ? parsed[key] : defaultValue;
        }
        return defaultValue;
    };
    useEffect(() => {
        if (!isSuperAdmin && userGovernorate) {
            setSelectedGov(userGovernorate);
            // console.log(userGovernorate)
        }
    }, [userGovernorate, isSuperAdmin]);
    // --- States للبيانات العامة ---
    const [visits, setVisits] = useState([]);
    const [locationsData, setLocationsData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // ربط الحالات بالقيم الابتدائية (URL > Session > Default)
    const [currentPage, setCurrentPage] = useState(parseInt(getInitialValue("page", 1)));
    const [pageSize, setPageSize] = useState(parseInt(getInitialValue("size", 12)));
    const [viewMode, setViewMode] = useState(getInitialValue("view", 'cards'));

    // --- States للفلاتر ---
    const [selectedGov, setSelectedGov] = useState(() => {
        // إذا لم يكن سوبر أدمن، نثبت محافظته فوراً ولا ننظر للـ URL
        if (!isSuperAdmin && userGovernorate) {
            return userGovernorate;
        }
        // إذا كان سوبر أدمن، نطبق المنطق المعتاد
        return getInitialValue("gov", "");
    }); const [selectedCity, setSelectedCity] = useState(getInitialValue("city", userCity || ""));
    const [selectedDistrict, setSelectedDistrict] = useState(getInitialValue("dist", ""));
    const [visitType, setVisitType] = useState(getInitialValue("type", ""));
    const [startDate, setStartDate] = useState(getInitialValue("from", ""));
    const [endDate, setEndDate] = useState(getInitialValue("to", ""));

    const [totalPages, setTotalPages] = useState(1);
    const [totalVisits, setTotalVisits] = useState(0);
    const [searchTrigger, setSearchTrigger] = useState(0);

    // --- تحديث الـ URL والـ sessionStorage عند كل تغيير ---
    useEffect(() => {
        const params = {
            page: currentPage,
            size: pageSize,
            view: viewMode,
            gov: selectedGov,
            city: selectedCity,
            dist: selectedDistrict,
            type: visitType,
            from: startDate,
            to: endDate
        };

        // حذف القيم الفارغة من الـ URL لشكل أنظف
        const cleanParams = Object.fromEntries(
            Object.entries(params).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
        );

        setSearchParams(cleanParams, { replace: true });
        sessionStorage.setItem("all_visits_filters", JSON.stringify(params));
    }, [currentPage, pageSize, viewMode, selectedGov, selectedCity, selectedDistrict, visitType, startDate, endDate]);


    // 1. جلب بيانات المواقع
    useEffect(() => {
        const fetchLocations = async () => {
            try {
                const params = {
                    size: 1000,
                };
                const res = await backEnd_request.get("/Locations?includeInactive=false", { params });
                setLocationsData(res.data.data || []);
            } catch (error) {
                console.error("Error fetching locations:", error);
            }
        };
        fetchLocations();
    }, []);

    const availableGovernorates = useMemo(() => [...new Set(locationsData.map(l => l.governorate))], [locationsData]);

    const availableCities = useMemo(() => {
        if (!selectedGov) return [];
        return [...new Set(locationsData.filter(l => l.governorate === selectedGov).map(l => l.city))];
    }, [locationsData, selectedGov]);

    const availableDistricts = useMemo(() => {
        if (!selectedCity) return [];
        return locationsData.filter(l => l.governorate === selectedGov && l.city === selectedCity).map(l => l.sector);
    }, [locationsData, selectedGov, selectedCity]);

    // 2. دالة جلب الزيارات
    const fetchVisits = async () => {
        setIsLoading(true);
        try {
            const res = await backEnd_request.get("/InspectionVisits/by-type", {
                params: {
                    page: currentPage,
                    size: pageSize,
                    visitType: visitType,
                    governorate: selectedGov,
                    city: selectedCity,
                    district: selectedDistrict,
                    from: startDate,
                    to: endDate
                },
            });
            if (res.data) {
                setVisits(res.data.data || []);
                setTotalVisits(res.data.total || 0);
                setTotalPages(Math.ceil((res.data.total || 0) / pageSize));
            }
        } catch (error) {
            console.error("Fetch Error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchVisits();
    }, [currentPage, searchTrigger, pageSize]);

    const handleSearchClick = () => {
        setCurrentPage(1);
        setSearchTrigger(prev => prev + 1);
    };

    const handlePageChange = (p) => {
        if (p < 1 || p > totalPages) return;
        setCurrentPage(p);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const resetFilters = () => {
        sessionStorage.removeItem("all_visits_filters");
        setSearchParams({}); // تفريغ الـ URL
        setStartDate("");
        setEndDate("");
        setVisitType("");
        // if (isSuperAdmin) setSelectedGov("");
        const defaultGov = isSuperAdmin ? "" : userGovernorate;
        setSelectedGov(defaultGov);

        setSelectedCity("");
        setSelectedDistrict("");
        setPageSize(12);
        setCurrentPage(1);
        setSearchTrigger(prev => prev + 1);
    };

    return (
        <div className="container py-4 min-vh-100" style={{ backgroundColor: "#f4f7f6", direction: "rtl" }}>

            {/* Header & Filters Card */}
            <div className="card border-0 shadow-sm rounded-4 mb-4 overflow-hidden">
                <div className="card-body p-4 bg-white">
                    <div className="row g-3 align-items-center">
                        <div className="col-12 col-lg-3 text-center text-lg-end border-start">
                            <h2 className="fw-bold text-dark mb-1">تقرير الزيارات</h2>
                            <span className="badge bg-info-subtle text-info rounded-pill px-3 py-2 mb-2">
                                إجمالي الزيارات: {totalVisits}
                            </span>
                            <button className="btn btn-link btn-sm text-decoration-none text-muted d-block w-100" onClick={resetFilters}>
                                <i className="bi bi-arrow-counterclockwise"></i> إعادة تعيين الفلاتر
                            </button>
                        </div>

                        <div className="col-12 col-lg-9">
                            <div className="row g-2">
                                <div className="col-md-3">
                                    <label className="small text-muted mb-1">نوع الزيارة</label>
                                    <select className="form-select border shadow-sm" value={visitType} onChange={(e) => setVisitType(e.target.value)}>
                                        <option value="">كل الأنواع</option>
                                        <option value="تموينية">تموينية</option>
                                        <option value="توعوية">توعوية</option>
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label className="small text-muted mb-1">المحافظة</label>
                                    <select className="form-select border shadow-sm" value={selectedGov} disabled={!isSuperAdmin} onChange={(e) => { setSelectedGov(e.target.value); setSelectedCity(""); setSelectedDistrict(""); }}>
                                        <option value="">اختر المحافظة</option>
                                        {availableGovernorates.map(g => <option key={g} value={g}>{g}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label className="small text-muted mb-1">المدينة</label>
                                    <select className="form-select border shadow-sm" value={selectedCity} disabled={!selectedGov} onChange={(e) => { setSelectedCity(e.target.value); setSelectedDistrict(""); }}>
                                        <option value="">اختر المدينة</option>
                                        {availableCities.map(c => <option key={c} value={c}>{c}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label className="small text-muted mb-1">المنطقة</label>
                                    <select className="form-select border shadow-sm" value={selectedDistrict} disabled={!selectedCity} onChange={(e) => setSelectedDistrict(e.target.value)}>
                                        <option value="">اختر المنطقة</option>
                                        {availableDistricts.map(d => <option key={d} value={d}>{d}</option>)}
                                    </select>
                                </div>

                                <div className="col-md-4">
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text bg-light border">من تاريخ</span>
                                        <input type="date" className="form-control border shadow-sm" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text bg-light border">إلى تاريخ</span>
                                        <input type="date" className="form-control border shadow-sm" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <button className="btn btn-primary w-100 shadow-sm fw-bold" onClick={handleSearchClick}>
                                        البحث
                                        <i className="bi bi-search me-2"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* View Mode Toggle */}
            <div className="d-flex justify-content-end mb-3 align-items-center gap-3">
                <div className="bg-white p-1 rounded-3 shadow-sm border d-inline-flex">
                    <button className={`btn btn-sm rounded-2 px-3 ${viewMode === 'cards' ? 'btn-primary' : 'btn-light text-muted'}`} onClick={() => setViewMode('cards')}>
                        <i className="bi bi-grid-fill me-1"></i> كروت
                    </button>
                    <button className={`btn btn-sm rounded-2 px-3 ${viewMode === 'table' ? 'btn-primary' : 'btn-light text-muted'}`} onClick={() => setViewMode('table')}>
                        <i className="bi bi-list-task me-1"></i> جدول
                    </button>
                </div>
            </div>

            {/* Results */}
            {isLoading ? (
                <div className="text-center py-5">
                    <div className="spinner-grow text-primary" role="status"></div>
                    <p className="mt-3 text-primary fw-bold">جاري تحميل البيانات...</p>
                </div>
            ) : visits.length === 0 ? (
                <div className="text-center py-5 bg-white rounded-4 shadow-sm border">
                    <i className="bi bi-search text-muted display-1"></i>
                    <h4 className="mt-3 text-dark">لا توجد نتائج!</h4>
                    <p className="text-muted">جرب تعديل فلاتر البحث أو التأكد من التواريخ المختارة.</p>
                </div>
            ) : (
                <div className="animate-fade-in">
                    {viewMode === 'cards' && (
                        <div className="row g-4">
                            {visits.map((visit) => (
                                <div key={visit.visitId} className="col-12 col-sm-6 col-xl-4">
                                    <div className="card border-0 h-100 shadow-hover transition-all rounded-4 overflow-hidden"
                                        onClick={() => navigate(`/admin/visit-details/${visit.visitUid}`)}
                                        style={{ cursor: 'pointer' }}>
                                        <div className="position-relative">
                                            <img src={visit.photos?.[0]?.photoUrl || img} className="card-img-top" style={{ height: '180px', objectFit: 'cover' }} alt="visit" />
                                            <div className="position-absolute top-0 start-0 m-2">
                                                <span className={`badge rounded-pill ${visit.visitType === 'تموينية' ? 'bg-danger' : 'bg-success'}`}>{visit.visitType}</span>
                                            </div>
                                            <div className="position-absolute bottom-0 end-0 m-2">
                                                <span className="badge bg-dark bg-opacity-75 rounded-pill small">
                                                    {new Date(visit.visitDate).toLocaleDateString('ar-EG')}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="card-body p-3">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <h6 className="fw-bold text-dark mb-0">{visit.establishment.name}
                                                    {/* زيارة رقم: {visit.visitId} */}
                                                </h6>
                                                {/* <small className="text-muted">{visit.establishment.name}</small> */}
                                            </div>
                                            <div className="small text-muted mb-2">
                                                <i className="bi bi-geo-alt-fill text-danger me-1"></i>
                                                {visit.governorate} - {visit.city} ({visit.district})
                                            </div>
                                            <p className="card-text small text-secondary mb-3" style={{ height: '40px', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                                                {visit.visitReport || "لا يوجد تقرير متاح لهذه الزيارة."}
                                            </p>
                                            <div className="bg-light p-2 rounded-3 border-start border-primary border-4">
                                                <div className="extra-small text-muted mb-1">رئيس الدورية:</div>
                                                <div className="small fw-bold text-dark">{visit.inspector1Name}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {viewMode === 'table' && (
                        <div className="card border-0 shadow-sm rounded-4 overflow-hidden border">
                            <div className="table-responsive">
                                <table className="table table-hover align-middle mb-0">
                                    <thead className="bg-light text-muted small">
                                        <tr>
                                            <th className="ps-4 py-3">التاريخ والنوع</th>
                                            <th>الموقع</th>
                                            <th>المفتش المسؤول</th>
                                            <th>التقرير</th>
                                            <th className="pe-4 text-center">الإجراء</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {visits.map((visit) => (
                                            <tr key={visit.visitId}
                                                onClick={() => navigate(`/admin/visit-details/${visit.visitUid}`)}
                                                style={{ cursor: 'pointer' }}>
                                                <td className="ps-4">
                                                    <div className="fw-bold">{new Date(visit.visitDate).toLocaleDateString('ar-EG')}</div>
                                                    <span className={`badge ${visit.visitType === 'تموينية' ? 'bg-danger-subtle text-danger' : 'bg-success-subtle text-success'} fw-normal`}>{visit.visitType}</span>
                                                </td>
                                                <td>
                                                    <div className="small fw-semibold">{visit.governorate}</div>
                                                    <div className="text-muted extra-small">{visit.city} - {visit.district}</div>
                                                </td>
                                                <td>
                                                    <div className="small">{visit.inspector1Name}</div>
                                                    <div className="extra-small text-muted font-monospace">المنشأة: {visit.establishment.name}</div>
                                                </td>
                                                <td style={{ maxWidth: '300px' }}>
                                                    <div className="text-truncate small text-muted">{visit.visitReport}</div>
                                                </td>
                                                <td className="pe-4 text-center">
                                                    <button className="btn btn-sm btn-outline-primary rounded-pill px-3">
                                                        <i className="bi bi-eye"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* Pagination */}
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 bg-white p-3 rounded-4 shadow-sm border">
                        <div className="text-muted small mb-3 mb-md-0">
                            عرض <strong>{visits.length}</strong> من إجمالي <strong>{totalVisits}</strong> زيارة
                        </div>
                        <div className="d-flex align-items-center gap-2 border-start ps-3">
                            <label className="extra-small text-muted mb-0">العناصر:</label>
                            <select
                                className="form-select form-select-sm border-0 bg-light shadow-none"
                                style={{ width: 'auto', cursor: 'pointer' }}
                                value={pageSize}
                                onChange={(e) => {
                                    setPageSize(parseInt(e.target.value));
                                    setCurrentPage(1);
                                }}
                            >
                                <option value={12}>12</option>
                                <option value={21}>21</option>
                                <option value={30}>30</option>
                                <option value={42}>42</option>
                            </select>
                        </div>
                        <nav>
                            <ul className="pagination pagination-sm mb-0 gap-1">
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link rounded-3 border-0 shadow-sm" onClick={() => handlePageChange(currentPage - 1)}>السابق</button>
                                </li>
                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                    .filter(p => p === 1 || p === totalPages || Math.abs(p - currentPage) <= 1)
                                    .map((p, idx, arr) => (
                                        <React.Fragment key={p}>
                                            {idx > 0 && arr[idx - 1] !== p - 1 && <span className="mx-1 text-muted">...</span>}
                                            <li className={`page-item ${currentPage === p ? 'active' : ''}`}>
                                                <button className="page-link rounded-3 border-0 shadow-sm px-3" onClick={() => handlePageChange(p)}>{p}</button>
                                            </li>
                                        </React.Fragment>
                                    ))}
                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                    <button className="page-link rounded-3 border-0 shadow-sm" onClick={() => handlePageChange(currentPage + 1)}>التالي</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            )}
        </div>
    );
}